import constants from '../shared/constants';
import requestWrapper from '../shared/lib/requestWrapper';

async function create(payload) {
    var response = await requestWrapper({
        url:    '/Schedule',
        method: 'POST',
        data: payload.data,
        baseURL: constants.sdn.baseUrl,
        notifications: payload.notifications
    });

    return response;
}

async function update(payload) {
    var response = await requestWrapper({
        url:    '/Schedule/' + payload.data.id,
        method: 'PUT',
        data: payload.data,
        baseURL: constants.sdn.baseUrl,
        notifications: payload.notifications
    });

    return response;
}

async function search(payload) {
    var response = await requestWrapper({
        url: '/Schedule/search',
        method: 'POST',
        data: payload.data,
        baseURL: constants.sdn.baseUrl,
        notifications: payload.notifications
    });

    return response;
}

const ScheduleService = {
    create, update, search
}

export default ScheduleService;